<template>
  <div v-if="mainConfig.enableWatchlist" :id="`add-to-watchlist-${lot.uuid}`" v-b-tooltip.hover class="ta-add-to-watchlist">
    <button
      :disabled="buttonDisabled"
      @click.stop="_toggleWatchlist"
      class="btn btn-link ta-btn-watchlist">
      <b-icon v-if="!lot.is_favored" :icon="icon"></b-icon>
      <b-icon v-else :icon="addedIcon"></b-icon>
      {{ label ? label : '' }}
    </button>
    <b-tooltip v-if="!is_authorized" container="artisioTimedAuctions" :target="`add-to-watchlist-${lot.uuid}`">
      {{ $t('Please login to proceed') }}
    </b-tooltip>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "WatchlistButton",
  props: {
    lot: {
      type: Object,
      required: true
    },
    label: {
      type: [String, Boolean],
      default: false
    },
    addedIcon: {
      type: String,
      default: "heart-fill"
    },
    icon: {
      type: String,
      default: "heart"
    },
  },
  data: () => ({
    buttonDisabled: false
  }),
  computed: {
    ...mapState(['is_authorized', 'mainConfig'])
  },
  methods: {
    ...mapActions(['addToFavourites']),
    async _toggleWatchlist() {
      this.buttonDisabled = true
      await this.addToFavourites()
      this.buttonDisabled = false;
    }
  }
}
</script>

<style lang="scss" scoped>
  .ta-add-to-watchlist {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
  }
</style>
